import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";

interface DonutChartProps {
  percentage: number; // da 0 a 100
  title: string,
}

export default function DonutChart({percentage, title}: DonutChartProps) {
  const remaining = 100 - percentage;
  const formattedPercentage = percentage.toFixed(2);

  const options: Highcharts.Options = {
    chart: {
      type: 'pie',
      height: 200,
      width: 200
    },
    title: {
      useHTML: true,
      text: `<div style="text-align: center">${title}<br/>${formattedPercentage}%</div>`,
      align: 'center',
      verticalAlign: 'middle',
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: '70%',
        dataLabels: {
          enabled: false
        },
        center: ['50%', '50%']
      }
    },
    series: [
      {
        type: 'pie',
        data: [
          {y: percentage, color: '#00bc8c'},
          {y: remaining, color: '#e0e0e0'}
        ]
      }
    ],
    credits: {
      enabled: false
    }
  };

  return <HighchartsReact highcharts={Highcharts} options={options}/>
}